import { Post } from '../helpers';

const RemoveAdmin = (blAdminID: number, channel: number): Promise<{ id: number }> => {
  return Post({ url: `/v3/admin/auth/remove-user-from-channel`, body: { blAdminID, channel } });
};

export default RemoveAdmin;
